import { useTranslation } from 'react-i18next';

import TextLink, { type Props as TextLinkProps } from '@/components/TextLink';
import { withLegalDocumentLocale } from '@/utils/legal-url';

import styles from './index.module.scss';

type Props = {
  readonly linkType?: TextLinkProps['type'];
  // eslint-disable-next-line react/boolean-prop-naming
  readonly inline?: boolean;
  readonly termsOfUseUrl?: string;
  readonly privacyPolicyUrl?: string;
};

const TermsLinks = ({ inline, termsOfUseUrl, privacyPolicyUrl, linkType = 'secondary' }: Props) => {
  const { t, i18n } = useTranslation();
  const termsHref = termsOfUseUrl
    ? withLegalDocumentLocale(termsOfUseUrl, i18n.language)
    : undefined;
  const privacyHref = privacyPolicyUrl
    ? withLegalDocumentLocale(privacyPolicyUrl, i18n.language)
    : undefined;

  return (
    <>
      {termsHref && (
        <TextLink
          className={styles.link}
          text="description.terms_of_use"
          href={termsHref}
          type={linkType}
          target="_blank"
          onClick={(event) => {
            event.stopPropagation();
          }}
        />
      )}
      {termsOfUseUrl && privacyPolicyUrl && inline && ` ${t('description.and')} `}
      {termsOfUseUrl && privacyPolicyUrl && !inline && <i className={styles.divider} />}
      {privacyHref && (
        <TextLink
          className={styles.link}
          text="description.privacy_policy"
          href={privacyHref}
          type={linkType}
          target="_blank"
          onClick={(event) => {
            event.stopPropagation();
          }}
        />
      )}
    </>
  );
};

export default TermsLinks;
